import { SpinBoundaryStartActionHandler } from "@slot/client-engine";
import type { ReplayPlugin } from "@slot/client-engine";
import type { Log } from "@slot/presentation";
import type { GameFeature } from "@slot/game-shell";
import { CellMultiplierPresenter, type CellMultiplierPort } from "./CellMultiplierPresenter";
import { UpdateCellMultipliersActionHandler } from "./replay/UpdateCellMultipliersActionHandler";

export interface CellMultiplierFeatureDeps {
  view: CellMultiplierPort;
  log: Log;
}

/**
 * The cell multiplier badges: a `CellMultiplierPresenter` driven by `update_cell_multipliers` (the board's badges) and
 * by every spin's boundary (a base spin starts clean).
 */
export const cellMultiplierFeature: GameFeature<CellMultiplierFeatureDeps, CellMultiplierPresenter, CellMultiplierPresenter> = {
  createPresenter: (deps) => new CellMultiplierPresenter(deps),

  createPlugin(target): ReplayPlugin {
    return {
      name: "cell-multipliers",
      actionHandlers: [
        new SpinBoundaryStartActionHandler(async (input) => target.onSpinBoundaryStart(input.spinModeIdentifier)),
        new UpdateCellMultipliersActionHandler(target),
      ],
    };
  },
};
